module.exports = __webpack_public_path__ + "static/fmsbonds-e31187887d2cbd187dd0f4e84ff39b62.png";